import {
  AnnotationsByProjectResultV2,
  CourseCurriculumResponseV2,
  CourseDetailsModelV2,
  CourseLearnerModelV2,
  CoursesVersionHistory,
  EventType,
  FeatureStatusResponse,
  FeedbackStateV2,
  UploadStateV2,
} from '../../models';
import { LiveSessionCourseModel } from '../../models/v2';
export type ActivityStateV2 =
  | 'type_lecture'
  | 'type_quiz'
  | 'type_assignment'
  | 'lecture_video'
  | 'lecture_article'
  | 'video_library';

export const initialFeedbackStateV2: FeedbackStateV2 = {
  isFeedbackModalOpen: false,
  fieldId: '',
  fieldKey: '',
  fieldModel: undefined,
  fieldValue: '',
};

// Initial State
export const initialCourseStateV2: CourseStateV2 = {
  courseDetails: {
    id: '',
    code: '',
    chain_id: '',
    title: '',
    slug: '',
    is_free: false,
    pricing: '',
    subtitle: '',
    desc: '',
    image: '',
    is_promote: false,
    skill_level: '',
    category: '',
    subcategory: '',
    language: '',
    topics: [],
    course_type: '',
    course_mode: '',
    included_in_promo: false,
    date_published: null,
    is_deleted: false,
    project: '',
    version: '',
    date_updated: '',
    date_created: '',
    category_name: '',
    unpublished_project: {
      id: '',
      published_course: '',
      unpublished_course: '',
      state: '',
      has_substantial_changes: false,
      user: 0,
      date_created: '',
      date_updated: '',
    },
    source: '',
    video_info: {
      status: '',
    },
    user: {
      id: 0,
      first_name: '',
      last_name: '',
      bio: '',
      photo: '',
      fullname: '',
      photo_url: '',
      headline: '',
      language: '',
      is_active: false,
      public_profile: '',
    },
    image_url: '',
    currency: 0,
    currency_preview: 0,
    primary_topic: '',
  },
  courseLerner: {
    id: '',
    title: '',
    unpublished_project: [],
    learners: [],
    requirements: [],
    objectives: [],
  },
  courseCurriculum: {
    count: 0,
    next: null,
    previous: null,
    results: {
      course_date_updated: '',
      sections: [],
    },
  },
  uploads: {},
  selectedActivityId: '',
  selectedSectionId: '',
  selectedSubsectionId: '',
  activityState: undefined,
  isActivityModalOpen: false,
  annotations: {
    annotations: [],
  },
  feedback: initialFeedbackStateV2,
  coursesVersionHistory: {
    version: '',
    previous_version: '',
    status: '',
    date_updated: '',
    date_created: '',
    history: [],
  },
  coursePermissions: {
    status: '',
    data: {
      ai_feature: false,
      is_owner: false,
      co_instructor_feature: false,
      has_collaborators: false,
      co_instructors: [],
      advanced_timing_feature: false,
      privacy_enrollment_enabled: false,
      free_style_booking_enabled: false,
      course_setting: {
        visible: false,
        captions: false,
        manage: false,
        reports: false,
        reviews: false,
        submit_for_review: false,
        assignments: false,
        qna: false,
        course_setting: false,
      },
    },
  },
  courseLoadError: null,
  isLoading: false,
  //livesession
  courses: [],
  coursesCount: 0,
  coursesLoaded: false,
  coursesCurrentPage: 1,
  course: {
    id: '',
    title: '',
    slug: '',
    status: '',
    image_url: '',
    course_mode: '',
    session_series_count: 0,
    live_session_count: 0,
    duration: 0,
    enroll_count: 0,
    product_slug: null,
    project: {
      id: '',
      published_course: '',
      unpublished_course: '',
      state: '',
      user: 0,
      date_created: '',
      date_updated: '',
      has_substantial_changes: false,
    },
  },

  classSetup: {
    duration: 0,
    max_participants: 0,
    minimum_booking_notice: 0,
    minimum_booking_notice_unit: '',
    before_event_buffer: 0,
    after_event_buffer: 0,
    time_slot_interval: 0,
    show_session_details_conflict: false,
    schedule_id: 0,
    schedule: {
      id: 0,
      name: '',
      time_zone: '',
      gmt_offset: '',
      is_default: false,
      availability: [],
      overrides: [],
    },
    // Session timing settings
    end_warning_minutes: 5,
    grace_period_minutes: 5,
    back_to_back_threshold_minutes: 15,
    auto_kick_enabled: true,
    // Late enrollment settings
    grant_recording_access_to_late_enrollees: true,
    // Booking slug settings
    custom_slug: '',
    is_booking_hidden: false,
  },
};

export interface CourseLoadErrorV2 {
  type: 'not_found' | 'invalid_uuid' | 'unauthorized' | 'server_error' | 'unknown';
  message: string;
  statusCode?: number;
}

export interface CourseStateV2 {
  courseDetails: CourseDetailsModelV2;
  courseLerner: CourseLearnerModelV2;
  courseCurriculum: CourseCurriculumResponseV2;
  uploads: { [referenceId: string]: UploadStateV2 };
  selectedActivityId: string;
  activityState: ActivityStateV2 | undefined;
  annotations: AnnotationsByProjectResultV2;
  isActivityModalOpen: boolean;
  selectedSectionId: string;
  selectedSubsectionId: string;

  feedback: FeedbackStateV2;
  coursesVersionHistory: CoursesVersionHistory;
  coursePermissions: FeatureStatusResponse;

  // Error state for course loading
  courseLoadError: CourseLoadErrorV2 | null;
  isLoading: boolean;
  //livesession
  courses: LiveSessionCourseModel[];
  coursesCount: number;
  coursesLoaded: boolean;
  coursesCurrentPage: number;
  course: LiveSessionCourseModel;
  classSetup: EventType;
}
